export const ADD_NOTIFICATION_TYPE = 'ADD_NOTIFICATION_TYPE';
export const ADD_REMOVAL_TYPE = 'ADD_REMOVAL_TYPE';
export const ADD_COURSE_CODE = 'ADD_COURSE_CODE';
export const ADD_STUDENT = 'ADD_STUDENT';
export const REMOVE_STUDENT = 'REMOVE_STUDENT';
export const ADD_DECLARATION = 'ADD_DECLARATION';
export const CLEAR_FORM_DATA = 'CLEAR_FORM_DATA';
export const CLEAR_SPECIFIC_FORM_DATA = "CLEAR_SPECIFIC_FORM_DATA";
export const LOAD_FORM_DATA = "LOAD_FORM_DATA";

export const addNotificationType = (value) => ({
    type: ADD_NOTIFICATION_TYPE,
    payload: value
});

export const addRemovalType = (value) => ({
    type: ADD_REMOVAL_TYPE,
    payload: value
});

export const addCourseCode = (value) => ({
    type: ADD_COURSE_CODE,
    payload: value
});

export const addStudent = (value) => ({
    type: ADD_STUDENT,
    payload: value
});

export const removeStudent = (value) => ({
    type: REMOVE_STUDENT,
    payload: value
});

export const clearFormData = () => ({
    type: CLEAR_FORM_DATA
});

export const clearSpecificFormData = (value) => ({
    type: CLEAR_SPECIFIC_FORM_DATA,
    payload: value
})

export const loadMplFormData = (value) => ({
    type: LOAD_FORM_DATA,
    payload: value
})

export const addDeclaration = (value) => ({
    type: ADD_DECLARATION,
    payload: value
});